import { StringParam, useQueryParams } from 'use-query-params';

export const CATEGORY_ID_QUERY_PARAM = 'categoryId';
export const CATEGORY_WIDGET_ID_QUERY_PARAM = 'categoryWidgetId';

export function useExpandedCategoryQueryParams() {
  const [query] = useQueryParams({
    [CATEGORY_ID_QUERY_PARAM]: StringParam,
    [CATEGORY_WIDGET_ID_QUERY_PARAM]: StringParam,
  });

  return {
    categoryId: query[CATEGORY_ID_QUERY_PARAM] ?? undefined,
    categoryWidgetId: query[CATEGORY_WIDGET_ID_QUERY_PARAM] ?? undefined,
  };
}
